var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15961 20.3909C1.9468 22.1161 1.9468 23.861 2.15961 25.5862M10.3294 6.23641C11.7175 5.18881 13.229 4.31582 14.8301 3.63708M3.65333 14.8171C4.33095 13.2162 5.20285 11.7046 6.2494 10.3164M16.5228 28.952V17.4458C16.5228 16.1152 18.0687 15.2737 19.3276 15.9195L30.55 21.6758C30.8402 21.8108 31.0859 22.0258 31.258 22.2956C31.4301 22.5655 31.5216 22.8789 31.5216 23.1989C31.5216 23.519 31.4301 23.8324 31.258 24.1022C31.0859 24.372 30.8402 24.5871 30.55 24.722L19.3308 30.4783C18.0687 31.1241 16.5228 30.2827 16.5228 28.952Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0363 2C34.6142 2 43.9973 11.4906 43.9973 23.199C43.9973 34.9074 34.6142 44.3981 23.0363 44.3981C15.0589 44.3981 8.12195 39.8908 4.58008 33.2572",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakesIcon);
export default __webpack_public_path__ + "static/media/takes_icon.cd4d191368ab0dfa2ade37dde221432e.svg";
export { ForwardRef as ReactComponent };